import {CARD_LOOKUP_REQUEST_SUCCESS, CARD_LOOKUP_REQUEST_SENT, CARD_LOOKUP_REQUEST_FAIL, 
        AUTH_REQUEST_FAIL, AUTH_REQUEST_SUCCESS, AUTH_REQUEST_SENT, UPDATE_CURRENCY,
        CAVV_LOOKUP_REQUEST_FAIL, CAVV_LOOKUP_REQUEST_SUCCESS, CAVV_LOOKUP_REQUEST_SENT,
        UPDATE_API_TOKEN, UPDATE_STORE_ID, RESET_CONFIGURATION, TOGGLE_CHALLENGE_IFRAM,
        UPDATE_ORDER_ID, UPDATE_PAN, UPDATE_NOTIFICATION_URL, UPDATE_CHALLENGE_URL, CHALLENGE_MADE,
        UPDATE_AMOUNT, UPDATE_EXPDATE, UPDATE_CAVV, UPDATE_ECI, UPDATE_CHALLENGE_DATA, CLEAR_HISTORY,
        CAVV_PURCHASE_REQUEST_SUCCESS, CAVV_PURCHASE_REQUEST_SENT, CAVV_PURCHASE_REQUEST_FAIL,
        RES_CAVV_PURCHASE_REQUEST_SUCCESS, RES_CAVV_PURCHASE_REQUEST_SENT, RES_CAVV_PURCHASE_REQUEST_FAIL,
        CAVV_PURCHASE_REC_REQUEST_SUCCESS, CAVV_PURCHASE_REC_REQUEST_SENT, CAVV_PURCHASE_REC_REQUEST_FAIL,
        RES_CAVV_PREAUTH_REQUEST_SUCCESS, RES_CAVV_PREAUTH_REQUEST_SENT, RES_CAVV_PREAUTH_REQUEST_FAIL,
        CAVV_PREAUTH_REQUEST_SUCCESS, CAVV_PREAUTH_REQUEST_SENT, CAVV_PREAUTH_REQUEST_FAIL, UPDATE_CRES,
        _3DS2, UPDATE_ON_EDIT_ID
    } from '../../actions/types'

const initialState = {
    prevSuccStep: 0, // the id of the most recent successful transaction (step)

    cardLookupResponse: "No request has been made.",
    authResponse: "No request has been made.",
    cavvLookupResponse: "No request has been made.",
    cavvPurchaseResponse: "No request has been made.",
    cavvPreAuthResponse: "No request has been made.",
    resCavvPurchaseResponse: "No request has been made.",
    resCavvPreauthResponse: "No request has been made.",
    cavvPurchaseRecResponse: "No request has been made.",

    cardLookupSuccess: false,
    authSuccess: false,
    cavvLookupSuccess: false,
    cavvPurchaseSuccess: false,
    cavvPreAuthSuccess: false,
    resCavvPurchaseSuccess: false,
    resCavvPreauthSuccess: false,
    cavvPurchaseRecSuccess: false,

    loading: false,
    authRequestNeeded: true,
    iframeOpen: false,

    config: {
        storeId: "store1", //"moneris"
        apiToken: "yesguy1", //"hurgle"
        order_id: "none",
        pan: "4606633870436092", // 4606633870436092, 4740611374762707
        notification_url: "https://yournotificationurl.com",
        expdate: "2310",
        amount: "1.00",
        currency: "124",
        cavv: "null", //kAABApFSYyd4l2eQQFJjAAAAAAA=
        eci: "null",
        challengeData: "null", //creq
        challengeURL: "",
        cres: "null",
        onEditId: 'none'
    },

    history: []
}

// eslint-disable-next-line
export default function(state = initialState, action) {
    if(action.feature === _3DS2) {
        switch(action.type) {
            case TOGGLE_CHALLENGE_IFRAM:
                return { ...state, iframeOpen: action.payload }
            case UPDATE_ON_EDIT_ID:
                return { ...state, config: { ...state.config, onEditId: action.payload }}
    

            case CARD_LOOKUP_REQUEST_SENT:
                return { ...state, cardLookupResponse: "", loading: true, cardLookupSuccess: false, history: [] }
            case CARD_LOOKUP_REQUEST_SUCCESS:
                return { 
                    ...state, 
                    cardLookupSuccess: true,
                    cardLookupResponse: action.payload, 
                    loading: false, 
                    history: [3],
                    prevSuccStep: 3
                }
            case CARD_LOOKUP_REQUEST_FAIL:
                return { ...state, cardLookupResponse: action.payload, loading: false }

            case AUTH_REQUEST_SENT:
                return { ...state, authResponse: "", loading: true, authRequestNeeded: true, authSuccess: false }
            case AUTH_REQUEST_SUCCESS:
                return { 
                    ...state, 
                    authSuccess: true, 
                    authResponse: action.payload, 
                    loading: false, 
                    authRequestNeeded: false, 
                    history: [ ...state.history, 4],
                    prevSuccStep: 4
                }
            case AUTH_REQUEST_FAIL:
                return { ...state, authSuccess: false, authResponse: action.payload, loading: false }

            case CAVV_LOOKUP_REQUEST_SENT:
                return { ...state, cavvLookupResponse: "", loading: true, cavvLookupSuccess: false }
            case CAVV_LOOKUP_REQUEST_SUCCESS:
                return { 
                    ...state, 
                    cavvLookupSuccess: true, 
                    cavvLookupResponse: action.payload, 
                    loading: false, 
                    history: [ ...state.history, 5],
                    prevSuccStep: 5
                }
            case CAVV_LOOKUP_REQUEST_FAIL:
                return { ...state, cavvLookupResponse: action.payload, loading: false }

            case CAVV_PURCHASE_REQUEST_SENT:
                return { ...state, cavvPurchaseResponse: "", loading: true, cavvPurchaseSuccess: false }
            case CAVV_PURCHASE_REQUEST_SUCCESS:
                return { 
                    ...state, 
                    cavvPurchaseSuccess: true, 
                    cavvPurchaseResponse: action.payload, 
                    loading: false, 
                    history: [ ...state.history, 7],
                    prevSuccStep: 7
                }
            case CAVV_PURCHASE_REQUEST_FAIL:
                return { ...state, cavvPurchaseResponse: action.payload, loading: false }

            case RES_CAVV_PURCHASE_REQUEST_SENT:
                return { ...state, resCavvPurchaseResponse: "", loading: true, resCavvPurchaseSuccess: false }
            case RES_CAVV_PURCHASE_REQUEST_SUCCESS:
                return { 
                    ...state, 
                    resCavvPurchaseSuccess: true, 
                    resCavvPurchaseResponse: action.payload, 
                    loading: false, 
                    history: [ ...state.history, 9],
                    prevSuccStep: 9
                }
            case RES_CAVV_PURCHASE_REQUEST_FAIL:
                return { ...state, resCavvPurchaseResponse: action.payload, loading: false }

            case CAVV_PURCHASE_REC_REQUEST_SENT:
                return { ...state, cavvPurchaseRecResponse: "", loading: true, cavvPurchaseRecSuccess: false }
            case CAVV_PURCHASE_REC_REQUEST_SUCCESS:
                return { 
                    ...state, 
                    cavvPurchaseRecSuccess: true, 
                    cavvPurchaseRecResponse: action.payload, 
                    loading: false, 
                    history: [ ...state.history, 11],
                    prevSuccStep: 11
                }
            case CAVV_PURCHASE_REC_REQUEST_FAIL:
                return { ...state, cavvPurchaseRecResponse: action.payload, loading: false }

            case CAVV_PREAUTH_REQUEST_SENT:
                return { ...state, cavvPreAuthResponse: "", loading: true, cavvPreAuthSuccess: false }
            case CAVV_PREAUTH_REQUEST_SUCCESS:
                return { 
                    ...state, 
                    cavvPreAuthSuccess: true, 
                    cavvPreAuthResponse: action.payload, 
                    loading: false, 
                    history: [ ...state.history, 8],
                    prevSuccStep: 8
                }
            case CAVV_PREAUTH_REQUEST_FAIL:
                return { ...state, cavvPreAuthResponse: action.payload, loading: false }

            case RES_CAVV_PREAUTH_REQUEST_SENT:
                return { ...state, resCavvPreauthResponse: "", loading: true, resCavvPreauthSuccess: false }
            case RES_CAVV_PREAUTH_REQUEST_SUCCESS:
                return { 
                    ...state, 
                    resCavvPreauthSuccess: true, 
                    resCavvPreauthResponse: action.payload, 
                    loading: false, 
                    history: [ ...state.history, 10],
                    prevSuccStep: 10
                }
            case RES_CAVV_PREAUTH_REQUEST_FAIL:
                return { ...state, resCavvPreauthResponse: action.payload, loading: false }

            case UPDATE_STORE_ID:
                return { ...state, config: {...state.config, storeId: action.payload} }
            case UPDATE_API_TOKEN:
                return { ...state, config: {...state.config, apiToken: action.payload} }
            case UPDATE_ORDER_ID:
                return { ...state, config: {...state.config, order_id: action.payload} }
            case UPDATE_PAN:
                return { ...state, config: {...state.config, pan: action.payload} }
            case UPDATE_NOTIFICATION_URL:
                return { ...state, config: {...state.config, notification_url: action.payload} }
            case UPDATE_AMOUNT:
                return { ...state, config: {...state.config, amount: action.payload} }
            case UPDATE_CURRENCY:
                return { ...state, config: {...state.config, currency: action.payload} }
            case UPDATE_EXPDATE:
                return { ...state, config: {...state.config, expdate: action.payload} }
            case UPDATE_CAVV:
                return { ...state, config: {...state.config, cavv: action.payload} }
            case UPDATE_ECI:
                return { ...state, config: {...state.config, eci: action.payload }}
            case UPDATE_CHALLENGE_DATA:
                return { ...state, config: {...state.config, challengeData: action.payload }}
            case UPDATE_CHALLENGE_URL:
                return { ...state, config: {...state.config, challengeURL: action.payload }}
            case UPDATE_CRES:
                return { ...state, config: {...state.config, cres: action.payload }}
            case CHALLENGE_MADE:
                return { ...state, authRequestNeeded: true }

            case CLEAR_HISTORY:
                return { ...state, history: [],
                    prevSuccStep: 0,

                    cardLookupResponse: "No request has been made.",
                    authResponse: "No request has been made.",
                    cavvLookupResponse: "No request has been made.",
                    cavvPurchaseResponse: "No request has been made.",
                    cavvPreAuthResponse: "No request has been made.",
                    resCavvPurchaseResponse: "No request has been made.",
                    resCavvPreauthResponse: "No request has been made.",
                    cavvPurchaseRecResponse: "No request has been made.",

                    cardLookupSuccess: false,
                    authSuccess: false,
                    cavvLookupSuccess: false,
                    cavvPurchaseSuccess: false,
                    cavvPreAuthSuccess: false,
                    resCavvPurchaseSuccess: false,
                    resCavvPreauthSuccess: false,
                    cavvPurchaseRecSuccess: false,

                    config: { 
                        ...state.config,
                        order_id: "none",
                        cavv: "null",
                        eci: "null",
                        challengeData: "null", //creq
                        challengeURL: "",
                        cres: "null"
                    }
                }

            case RESET_CONFIGURATION:
                return { ...state, config: initialState.config }
            
            default:
                return state
        }
    }
    else {
        return state
    }
}